<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-轮播图
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
  
      <el-form-item label="分类code">
        <el-select placeholder="请选择code" v-model="curItem.params.code">
          <el-option  v-for="(item,index) in curItem.params.code_arr" :key="index" :value="item.code" :label="item.code">
          </el-option>
        </el-select>
        <p>code决定获取哪一个分类</p>
      </el-form-item>
      <!--轮播高度-->
      <el-form-item label="图片高度：" v-if="curItem.params.type == '1'">
        <el-slider v-model="curItem.style.height" :format-tooltip="formatTooltip" :min="50" :max="500"></el-slider>
      </el-form-item>
      <el-form-item label="图片宽度：" v-if="curItem.params.type == '1'">
        <el-slider v-model="curItem.style.width" :format-tooltip="formatTooltip" :min="100" :max="500"></el-slider>
      </el-form-item>


      <el-form-item label="限制起点位置">
        <el-slider v-model="curItem.params.limit_start" :format-tooltip="formatTooltipa" :min="0" :max="99"></el-slider>
      </el-form-item>
      <el-form-item label="限制终点位置">
        <el-slider v-model="curItem.params.limit_end" :format-tooltip="formatTooltipa" :min="0" :max="99"></el-slider>
      </el-form-item>
      <!-- 类型 -->
      <el-form-item label="类型：">
        <el-radio-group v-model="curItem.params.type" @change="editSet">
          <el-radio :label="item.id" v-for="(item,index) in curItem.params.type_arr" :key="index">{{ item.text }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="跳转链接：">
        <div class="d-s-c">
              <div class="url-box flex-1">
              <span class="key-name">链接名称：</span>
              <el-input :value="curItem.linkName+curItem.linkUrl"></el-input>
            </div>
            <div class="url-box ml10">
              <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
            </div>
            </div>

            <p>决定点击图片跳转的页面，无法单独设置，每个图片跳转页面相同，获取的分类不同</p>
        </el-form-item>
    </el-form>

    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink>
  </div>
</template>

<script>
import Setlink from "@/components/setlink/Setlink";
import AdvApi from "@/api/adv.js";
export default {
  components: {
    Setlink,
  },
  data() {
    return {
      advList: [],
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    };
  },
  props: ["curItem", "selectedIndex"],
  created() {
    // this.getAdvList();
  },
  methods: {
    formatTooltip(val) {
      return (val*2) + ' px';
    },
    formatTooltipa(val) {
      return (val);
    },
    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.curItem.linkUrl = e.url;
        this.curItem.linkName = "链接到" + " " + e.type + " " + e.name;
      }
    },
  },
};
</script>

<style>
.video {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video video {
  width: 200px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Categorya.vue